import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { ProfileType } from '@/@types/graphql-types';
import type { ProfileInfoFragment } from '@/features/user-profile/graphql/fragments/ProfileInfo.fragment';

import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextRecommendationCardTitleDetailProfile',
  props: {
    profile: null,
    customProfileType: null
  },
  setup(__props: any) {

const props = __props as {
	profile: ProfileInfoFragment;
	customProfileType?: string | null | undefined;
};

const { t, tc } = useI18n();



const specialProfileTypes = [
	ProfileType.Actor,
	ProfileType.Director,
	ProfileType.Influencer,
	ProfileType.Producer,
	ProfileType.Vip,
	ProfileType.Writer,
];

const profileTypeMapping: Record<ProfileType, string> = {
	ACTOR: tc('WEBAPP_ACTOR'),
	DIRECTOR: tc('WEBAPP_DIRECTOR'),
	INFLUENCER: tc('WEBAPP_INFLUENCER'),
	JW_EDITOR: tc('WEBAPP_JUSTWATCH_EDITOR'),
	JW_EMPLOYEE: tc('WEBAPP_JUSTWATCH_EMPLOYEE'),
	PRODUCER: tc('WEBAPP_PRODUCER'),
	PRO_USER: 'Pro',
	USER: '',
	WRITER: tc('WEBAPP_WRITER'),
	VIP: tc('WEBAPP_VIP'),
};

const displayRole = computed(() =>
	props.profile.profileType ? profileTypeMapping[props.profile.profileType] : tc('WEBAPP_JUSTWATCH_EDITOR')
);

const isSpecial = computed(() => {
	if (props.customProfileType) return true;

	return props.profile.profileType != null && specialProfileTypes.includes(props.profile.profileType);
});

const recommendationCountText = computed(() =>
	props.profile.textRecommendationsCount === 1
		? tc('WEBAPP_1_RECOMMENDATION')
		: t('WEBAPP_NR_OF_RECOMMENDATIONS', { count: props.profile.textRecommendationsCount })
);

return { __sfc: true,t, tc, props, specialProfileTypes, profileTypeMapping, displayRole, isSpecial, recommendationCountText }
}

})